import script from "./HeroLoadingLight.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeroLoadingLight.vue?vue&type=script&lang=ts&setup=true"

import "./HeroLoadingLight.vue?vue&type=style&index=0&id=2b87c5e1&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b87c5e1"]])

export default __exports__